/**
 * markdownLatex.ts
 * 模型输出里的 LaTeX 公式定界符五花八门（DeepSeek 等常输出 `[ ... ]` 包裹的公式），
 * 而 remark-math 只识别 `$...$` / `$$...$$`。渲染前做一次归一化：
 *  - 块级：独立成行的 `[ ... ]` / `\[ ... \]`（内容含反斜杠命令）→ `$$ ... $$`
 *  - 行内：`\[ ... \]` / 含反斜杠命令的 `[ ... ]`（排除链接、任务列表）→ `$ ... $`
 */

const BLOCK_BRACKET = /^\[\s*([\s\S]*?)\s*\]\s*$/gm;
const BLOCK_ESCAPED = /^\\\[\s*([\s\S]*?)\s*\\\]\s*$/gm;
const INLINE_ESCAPED = /\\\[([^\]\n]+?)\\\]/g;
const INLINE_BRACKET = /(^|[^\\[\]])\[([^\]\n]+?)\](?!\s*\(|\[)/g;

export function preprocessLatexFormulas(md: string): string {
  if (!md) return md;
  let out = md;

  // 块级：`[ ... ]`（整行，含 \ 命令）
  out = out.replace(BLOCK_BRACKET, (m, inner: string) => {
    if (!/\\/.test(inner)) return m;
    return `$$\n${inner.trim()}\n$$`;
  });
  // 块级：`\[ ... \]`（LaTeX 标准转义形式）
  out = out.replace(BLOCK_ESCAPED, (_m, inner: string) => `$$\n${inner.trim()}\n$$`);
  // 行内：`\[ ... \]`
  out = out.replace(INLINE_ESCAPED, (_m, inner: string) => `$${inner.trim()}$`);
  // 行内：`[ ... ]`（含 \ 命令；排除 markdown 链接/引用语法）
  out = out.replace(INLINE_BRACKET, (m, pre: string, inner: string) => {
    if (!/\\/.test(inner)) return m;
    return `${pre}$${inner.trim()}$`;
  });

  return out;
}
